<svg [ngClass]="iconClasses()" aria-hidden="true" [attr.aria-label]="label() || icon()" role="img">
  <use [attr.href]="href()" class="contents"></use>
</svg>
